import { FaCreditCard, FaFilter } from "react-icons/fa";
import ExpenseCard from "./ExpenseCard";
import styled from "styled-components";
import { Utils } from "../../../utils";
import { useState } from "react";
import FilterExpensePopup from "./FilterExpesnePopup";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  font-weight: bold;
  color: #000000;
  font-size: 1.1rem;

  span {
    color: #28a745;
    margin-left: 0.3rem;
  }
`;

const ButtonGroup = styled.div<{ solid?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  button {
    border: 1px solid #28a745;
    background: ${(props) => (props.solid ? "#28a745" : "#ffffff")};
    color: ${(props) => (props.solid ? "#fff" : "#28a745")};
    padding: 0.4rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.3rem;
  }
`;

const All = ({ data, showPay = false, onPay, showFilter= false  }: any) => {
  const [filters, setFilters] = useState({ statuses: [], employees: [] });
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleFilterChange = (newFilters: any) => {
    setFilters(newFilters);
  };

  const filteredData = data.filter((item: any) => {
    const matchStatus =
      filters.statuses.length === 0 || filters.statuses.includes(item.status);
    const matchEmployee =
      filters.employees.length === 0 ||
      filters.employees.includes(item.employee?.name);
    return matchStatus && matchEmployee;
  });

  return (
    <div style={{ maxWidth: "85%", margin: "auto"}} >
      <div style={{ position : "relative" }}>
        <Header>
        <Title>
          All <span>({data.length})</span>
        </Title>

        {showFilter && <ButtonGroup>
          <button onClick={() => setShowFilterPopup(!showFilterPopup)}>
            <FaFilter /> Filter
          </button>
        </ButtonGroup>}
      </Header>

      {showFilterPopup && (
        <FilterExpensePopup
          data={data}
          onFilterChange={handleFilterChange}
          onClose={() => setShowFilterPopup(false)}
        />
      )}
      </div>

      {showPay && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <ButtonGroup solid>
            <button onClick={() => onPay(null, true)}>
              <FaCreditCard /> Pay All
            </button>
          </ButtonGroup>
        </div>
      )}

      <div>
        {filteredData?.map((item: any, index: number) => (
          <ExpenseCard
            key={item?.id}
            data={item}
            bgColor={
              Utils.LIGHT_COLOR_CODES[index % Utils.LIGHT_COLOR_CODES.length]
            }
            onPay={onPay}
            showPay={showPay}
          />
        ))}
      </div>
    </div>
  );
};

export default All;
